import ChangeProductOwner from "../../../components/@products/products/ChangeProductOwner";

import { routeTypes } from "../../../../../hooks/useSystemRoutes";

export default function ProductChangeOwnerPage() {

    return (
        <ChangeProductOwner
            routeType={routeTypes.admin}
        />
    )
}       